import { endOfDay, format, fromUnixTime, parseISO, startOfDay } from "date-fns"
import { formatInTimeZone } from "date-fns-tz"

export const parseIsoFormat = (isoString, formatText) => {
  if (!isoString) return null
  const date = parseISO(isoString)
  return format(date, formatText || "yyyy/MM/dd HH:mm")
}

export const parseTimestampFormat = (timestamp, formatText = "yyyy/MM/dd HH:mm") => {
  if (!timestamp) return null
  const date = fromUnixTime(timestamp)
  return format(date, formatText || "yyyy/MM/dd HH:mm")
}

export const dateToUnixTimestamp = (date) => {
  if (!date) {
    return 0
  }

  return Math.floor(date?.getTime() / 1000)
}

export const dateFormat = (date, formatText) => {
  try {
    if (!date) {
      return null
    }

    return format(date, formatText)
  } catch (e) {
    console.error(e)
  }

  return null
}

export const dateFormatWithTimezone = (date, timezone = "Asia/Taipei", formatText = "yyyy-MM-dd HH:mm:ssXXX") => {
  try {
    if (!date) {
      return null
    }

    return formatInTimeZone(date, timezone, formatText)
  } catch (e) {
    console.error(e)
  }

  return null
}

export const unixTimestampToDate = (timestamp) => {
  if (!timestamp) {
    return new Date(0)
  }

  return new Date(timestamp * 1000)
}

export const getEndOfDayString = (date, formatText = "yyyy-MM-dd HH:mm:ss") => {
  if (!date) {
    return null
  }

  return dateFormat(endOfDay(date), formatText)
}

export const getStartOfDayString = (date, formatText = "yyyy-MM-dd HH:mm:ss.SSS'Z'") => {
  if (!date) {
    return null
  }

  return dateFormat(startOfDay(date), formatText)
}
